import { Text, TextProps, Box } from '@chakra-ui/react';
import { formatAmount } from 'lib/finance';
import { useFinance } from 'contexts/FinanceContext';
import { Transaction } from 'types/finance';

interface AmountDisplayProps extends TextProps {
  amount: number;
  type?: 'income' | 'expense' | 'neutral';
  showSign?: boolean;
  transaction?: Transaction;
}

export default function AmountDisplay({
  amount,
  type = 'neutral',
  showSign = false,
  transaction,
  ...rest
}: AmountDisplayProps) {
  const { currencySymbol, getDisplayAmount } = useFinance();
  const color =
    type === 'income'
      ? 'green.500'
      : type === 'expense'
        ? 'red.500'
        : undefined;

  const prefix =
    showSign && type === 'income'
      ? '+'
      : showSign && type === 'expense'
        ? '-'
        : '';

  const display =
    transaction?.source === 'wallet'
      ? getDisplayAmount(transaction)
      : amount;

  return (
    <Box textAlign="inherit">
      <Text color={color} fontWeight="700" {...rest}>
        {prefix}
        {currencySymbol}
        {formatAmount(display)}
      </Text>
      {transaction?.source === 'wallet' &&
        transaction.tokenSymbol &&
        transaction.tokenAmount != null && (
          <Text fontSize="xs" color="secondaryGray.600" fontWeight="500">
            {transaction.tokenAmount} {transaction.tokenSymbol}
          </Text>
        )}
    </Box>
  );
}
